import React from 'react'

export default (props) => {
    return (
        <div className={props.underline ? "header-title underline" : "header-title"}>
            {props.title}
        </div>
    )
}